import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engelhardt',
  templateUrl: './engelhardt.component.html',
  styleUrls: ['./../app.component.css']
})
export class EngelhardtComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
